// Reihenfolge, in der die Zelte zum Essen gerufen werden.
// Gilt nur für Frühstück und Abendessen (Quelle: Aushang "zum Frühstück und Abendbrot").

export const ESSENSREIHENFOLGE = {
  Sonntag: {
    Abendessen: [
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
      'Kai & Nya',
      'Palermo & Neapel',
      'Vincent van Gogh & Frida Kahlo',
      'Tom & Jerry',
      'Flip & Flop',
      'Krümelmonster & Keksdose',
      'Six & Seven',
    ],
  },
  Montag: {
    Fruehstueck: [
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Max & Gidget',
      'Flip & Flop',
      'Tom & Jerry',
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Kai & Nya',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
      'Palermo & Neapel',
      'Vincent van Gogh & Frida Kahlo',
    ],
    Abendessen: [
      'Palermo & Neapel',
      'Vincent van Gogh & Frida Kahlo',
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Tom & Jerry',
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
      'Kai & Nya',
    ],
  },
  Dienstag: {
    Fruehstueck: [
      'Mailand & Verona',
      'Po & Tigeress',
      'Kai & Nya',
      'Lidl & Aldi',
      'Vincent van Gogh & Frida Kahlo',
      'Palermo & Neapel',
      'Wade & Ember',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Tom & Jerry',
    ],
    Abendessen: [
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Tom & Jerry',
      'Six & Seven',
      'Po & Tigeress',
      'Kai & Nya',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Vincent van Gogh & Frida Kahlo',
      'Palermo & Neapel',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Wade & Ember',
    ],
  },
  Mittwoch: {
    Fruehstueck: [
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Tom & Jerry',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Vincent van Gogh & Frida Kahlo',
      'Palermo & Neapel',
      'Kai & Nya',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
    ],
    Abendessen: [
      'Wade & Ember',
      'Max & Gidget',
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Tom & Jerry',
      'Mailand & Verona',
      'Po & Tigeress',
      'Kai & Nya',
      'Lidl & Aldi',
      'Vincent van Gogh & Frida Kahlo',
      'Palermo & Neapel',
    ],
  },
  Donnerstag: {
    Fruehstueck: [
      'Tom & Jerry',
      'Six & Seven',
      'Krümelmonster & Keksdose',
      'Flip & Flop',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
      'Kai & Nya',
      'Palermo & Neapel',
      'Vincent van Gogh & Frida Kahlo',
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Max & Gidget',
      'Sajaboys & Huntrix',
    ],
    Abendessen: [
      'Kai & Nya',
      'Lidl & Aldi',
      'Mailand & Verona',
      'Po & Tigeress',
      'Vincent van Gogh & Frida Kahlo',
      'Palermo & Neapel',
      'Sajaboys & Huntrix',
      'Das Biest & Die Schöne',
      'Wade & Ember',
      'Max & Gidget',
      'Flip & Flop',
      'Tom & Jerry',
      'Six & Seven',
      'Krümelmonster & Keksdose',
    ],
  },
};
